// extracted by mini-css-extract-plugin
export default {"pill":"CountPill_pill__+sScE"};